// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://elauvkrovgtmcraknxyp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVsYXV2a3Jvdmd0bWNyYWtueHlwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUyOTA4ODQsImV4cCI6MjA3MDg2Njg4NH0.4NaP-HVoqmNS8EcVNk1xdTtiVatdGw_RnsPPVdveRzc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});